import Box from '@mui/material/Box';
import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { loadOrganizations, selectOrganizations } from '../store/organizations.reducer';
import { OrganizationsTableGrid } from '../Components/OrganizationsTableGrid';

export const Organizations = () => {
    const dispatch = useAppDispatch();
    const organizations = useAppSelector(selectOrganizations);

    useEffect(() => {
        dispatch(loadOrganizations());
    }, []);

    return (
        <Box sx={{ width: '100%', height: '100%', p: 2, boxSizing: 'border-box' }}>
            {organizations && <OrganizationsTableGrid organizations={organizations} />}
        </Box>
    );
};
